<mat-card>
    
    <mat-card-content>

        <div style="background: url('../../assets/img/morceau/titre.png');height: 60px; background-size: 100% 100%;
                width: 100%;color: #2F4395; font-size: 18px;">

<div style="float: left;margin-top:5px;">
    <img src="../../assets/img/morceau/4.png" height="40">
                Stands
            </div>
            <div style="float: right; cursor: pointer;" (click)="gogtoDetail()">
                <img src="../../assets/img/morceau/edit.png">
            </div>

        </div>

<div class="content2">


        <mat-form-field class="example-full-width">

            <input matInput placeholder="Stands" [value]="metrageS" (click)='gogtoDetail()' readonly>
        </mat-form-field>

        <div *ngFor="let stand of stands" style="text-align: center;">
            <div style="border: solid darkblue;padding: 2px;font-size: 10px; "
                [ngStyle]="{'width.px': stand.width*10,'height.px': stand.height*10 }">{{stand.height}}x{{stand.width}}
            </div>
         
            <a href="http://admin-pc:8080/NAPEC2020/floorv.xhtml?stand={{stand.idStand}}" target="_blank">
            <span style="color: #a94442;font-weight: bolder;">{{stand.num}} </span>{{stand.standType}}
            <span style="color: #704300;">{{stand.superficie}}m²</span>
</a>



        </div>
    </div>

    </mat-card-content>
</mat-card>